import { WithApplicationFromRoute } from '@features/applications/components/with-application-from-route.tsx';
import { EndStep } from '@features/wizard/components/end-step.tsx';

const EndPage = WithApplicationFromRoute(EndStep);

export default EndPage;
